module.exports = __webpack_public_path__ + "img/download.8585df10.svg";